<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>

@import "assets/css/index.css";


html, body {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}


#app {
  width: 100%;
  height: 100%;
  color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/App.vue